import DocumentReadabilityCallout from "layout/documentReadabilityReport/DocumentReadabilityCallout";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

const OFFSET_CORRECTION_TOP = 20;
const OFFSET_CORRECTION_LEFT = -20;

const DocumentReadabilityContentSuggestion = ({
  issueHit,
  content,
  issueCls,
}) => {
  const [hovered, setHovered] = useState(false);
  const [position, setPosition] = useState(undefined);
  const calloutTargetRef = useRef(null);

  const determinePosition = (e) => ({
    x: e.clientX + OFFSET_CORRECTION_LEFT,
    y: e.clientY + OFFSET_CORRECTION_TOP,
  });

  const handleMouseEnter = (e) => {
    setPosition(determinePosition(e));
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    setPosition(undefined);
  };

  const handleMouseMove = (e) => {
    setPosition(determinePosition(e));
  };

  const renderCallout = () =>
    hovered && (
      <DocumentReadabilityCallout
        position={position}
        targetRef={calloutTargetRef}
        classes={`readability_callout suggestion issue_type_${issueCls}`}
      >
        <div className={"readability_callout__score"}>
          <div className={"readability_callout__score__title"}>
            {issueHit.title}
          </div>
          <div className={"readability_callout__score__body"}>
            {issueHit.description}
          </div>
        </div>
      </DocumentReadabilityCallout>
    );

  return (
    <span
      className={`highlight highlight_${issueCls}`}
      ref={calloutTargetRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {content}
      {renderCallout()}
    </span>
  );
};

export default DocumentReadabilityContentSuggestion;

DocumentReadabilityContentSuggestion.propTypes = {
  issueHit: PropTypes.any.isRequired,
  content: PropTypes.string.isRequired,
  issueCls: PropTypes.string.isRequired,
};
